import { render, staticRenderFns } from "./LanguageFieldValueMapper.vue?vue&type=template&id=787b19d6&scoped=true"
import script from "./LanguageFieldValueMapper.vue?vue&type=script&lang=js"
export * from "./LanguageFieldValueMapper.vue?vue&type=script&lang=js"
import style0 from "./LanguageFieldValueMapper.vue?vue&type=style&index=0&id=787b19d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787b19d6",
  null
  
)

export default component.exports